export const HOME_CHANNEL_ID = "_internal.gc.app.home.index";
export const ORIGINALS_CHANNEL_ID = "_internal.gc.app.originals.index";

const DEFAULT_NAVBAR_HEIGHT = 76;
export const DEFAULT_SIDEBAR_WIDTH = 274;
export const DEFAULT_SIDEBAR_WIDTH_WITH_PADDING = 300;

const queryParams =
  typeof window !== "undefined"
    ? new URLSearchParams(window.location.search)
    : new URLSearchParams();

// If standalone is set to 1, the navbar will be hidden (RootLayout.tsx)
// If so, the height of the navbar should be 0.
export const NAVBAR_HEIGHT =
  queryParams.get("standalone") === "1" ? 0 : DEFAULT_NAVBAR_HEIGHT;

export const RIBBON_BANNER_HEIGHT = 50;

// Z-index hierarchy for layered UI elements
// Navbar should be above everything, account menu above slide-in but below navbar
export const Z_INDEX_READER_BANNER = 1400;
export const Z_INDEX_MODAL = 1409;
export const Z_INDEX_SLIDE_IN_MENU = 1410;
export const Z_INDEX_NAVBAR_POPOVER = 1415;
export const Z_INDEX_NAVBAR = 1420;
export const Z_INDEX_POPOVER = 1500;
export const Z_INDEX_PORTAL_ESCAPE = 9999;

export enum SLIDE_IN_MENUS {
  settings = "Settings",
  allPages = "All pages",
  comicDetails = "Series info",
  addTo = "Add to library",
  comments = "Comments",
  publisher = "Publisher Profile",
  releaseInfo = "Release info",
  userProfile = "User Profile",
  bundleDetails = "Bundle Details",
}

export enum ENTITY_TYPES {
  COMICS = 3,
  RELEASES = 4,
}
